/**
 * PIM Router
 * Main routing component for the PIM feature
 */

import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppScopeBanner } from '@/components/AppScopeBanner';

// Lazy load components for code splitting
// Use the consolidated PIM page (mounts PIMDashboardFixed)
const PimPage = React.lazy(() => import('../../pages/PimPage'));
const Catalog = React.lazy(() => import('./Catalog'));
const ItemWizardAgentic = React.lazy(() => import('./ItemWizardAgentic'));
const ItemDetail = React.lazy(() => import('./ItemDetail'));
const ItemDetailV2 = React.lazy(() => import('./ItemDetailV2'));
const BulkImport = React.lazy(() => import('./BulkImport'));
const Settings = React.lazy(() => import('./Settings'));

function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    </div>
  );
}

export default function PimRouter() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <div className="px-6 pt-4">
        <AppScopeBanner />
      </div>
      <Routes>
        {/* PimPage mounts the current dashboard implementation */}
        <Route index element={<PimPage />} />
        <Route path="/" element={<PimPage />} />
        {/* Legacy routes (avoid broken legacy PIM item detail pages) */}
        <Route path="/catalog" element={<Navigate to="/pim" replace />} />
        <Route path="/items/new" element={<ItemWizardAgentic />} />
        <Route path="/items/:id" element={<ItemDetailV2 />} />
        <Route path="/bulk" element={<BulkImport />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Suspense>
  );
}
